import {CyphClient} from './index';

let script = document.querySelector('script#cyphlens-sdk-js');
let scriptURL = script.src.split("?")[1];
const urlParams = new URLSearchParams("?"+scriptURL);
const clientId = urlParams.get('clientId');
window['CyphClient'] = CyphClient(clientId);
